import React from 'react'

function SvgTutorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M16.666 17.5c0-1.163 0-1.745-.143-2.218A3.333 3.333 0 0014.3 13.06c-.473-.143-1.055-.143-2.218-.143H7.916c-1.163 0-1.744 0-2.217.143a3.333 3.333 0 00-2.222 2.222c-.144.473-.144 1.055-.144 2.218M13.75 6.25a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
      ></path>
    </svg>
  )
}

export default SvgTutorIcon
